import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649ac277"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-backdrop" }
const _hoisted_2 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_3 = { class: "modal-title" }

import { useModalDefinition } from './hooks/use-modal-definition';
import { useModalControls } from './hooks/use-modal-controls';
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { Size } from './constants';

interface Props {
  title?: string;
  hideHeader?: boolean;
  hideCloseButton?: boolean;
  noBodyPadding?: boolean;
  size?: string|number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    title: null,
    hideHeader: { type: Boolean },
    hideCloseButton: { type: Boolean },
    noBodyPadding: { type: Boolean },
    size: null
  },
  setup(__props: any) {

const props = __props as {
  title?: string;
  hideHeader?: boolean;
  hideCloseButton?: boolean;
  noBodyPadding?: boolean;
  size?: string|number;
}



const styles = computed(() => {
  let width;

  const stylesObject: Record<string, any> = {};

  if (typeof props.size === 'number') {
    width = props.size;
  } else {
    switch (props.size) {
      case Size.sm: width = 200; break;
      case Size.md: width = 400; break;
      case Size.lg: width = 600; break;
      case Size.xl: width = 900; break;
      case Size.xxl: width = 1200; break;
    }
  }
  if (width) {
    stylesObject.width = `${width}px`;
  }

  return stylesObject;
})

const modalDefinition = useModalDefinition();
const modalControls = useModalControls();

onBeforeUnmount(() => {
  modalDefinition.onClose && modalDefinition.onClose();
});
onMounted(() => {
  modalDefinition.onOpen && modalDefinition.onOpen();
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-wrapper",
      style: _normalizeStyle(_unref(styles))
    }, [
      (!__props.hideHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
            (__props.hideCloseButton !== true)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "modal-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalControls).close()))
                }, [
                  _createVNode(_component_FontAwesomeIcon, { icon: "times" })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", {'modal-body-no-padding': __props.noBodyPadding}])
      }, [
        (__props.hideHeader && __props.hideCloseButton !== true)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-close-corner",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalControls).close()))
            }, [
              _createVNode(_component_FontAwesomeIcon, { icon: "times" })
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 4)
  ]))
}
}

})